var LocaleMessageEditor = /** @class */ (function () {
    function LocaleMessageEditor() {
        this.prevContenEditable = undefined;
    }
    LocaleMessageEditor.prototype.instrumentMessageHTML = function (target, inspectedElement, callback) {
        var _a;
        if (typeof (target === null || target === void 0 ? void 0 : target.contentEditable) != 'undefined' && target.contentEditable !== 'true' && target.children.length == 0) {
            // const id = this.devTools.getIDForNode(target)
            // const ownerList = this.cacheComponentIds.get
            // console.log('click B editable', id, ownerList, this.cacheComponentIds.get(id - 1), this.cacheComponentIds.get(id), this.cacheComponentIds.get(id + 1), this.cacheComponentIds)
            //const inspectedElement = this.cacheComponentIds.get(id)
            if (target == this.prevContenEditable) {
                return;
            }
            this.prevContenEditable = target;
            if (inspectedElement.displayName == "FormattedMessage") {
                var messageId = (_a = inspectedElement.props.data) === null || _a === void 0 ? void 0 : _a.id;
                console.log('click C FormattedMessage', messageId, inspectedElement);
                if (messageId) {
                    var self_1 = this;
                    editMessageHTML(messageId, target, function (changed) {
                        callback(changed);
                        self_1.prevContenEditable = undefined;
                    });
                }
            }
        }
    };
    return LocaleMessageEditor;
}());
export { LocaleMessageEditor };
function editMessageHTML(messageId, target, success) {
    target.contentEditable = 'true';
    target.focus();
    function blurHandler(event) {
        var _a;
        target.contentEditable = 'false';
        target.removeEventListener('blur', blurHandler);
        var blurTarget = event === null || event === void 0 ? void 0 : event.target;
        var newMessageValue = (_a = blurTarget.innerText) !== null && _a !== void 0 ? _a : '';
        console.log('click edittedMessage', messageId, newMessageValue);
        success({ messageId: messageId, newMessageValue: newMessageValue });
    }
    target.addEventListener('blur', blurHandler);
    // TODO ESC key target.addEventListener('input', inputHandler)
}
